import { createSlice } from '@reduxjs/toolkit';

export const oneTrustLocale = createSlice({
  name: 'ONETRUST_LOCALE',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setOneTrustLocale(state, action) {
      return {
        ...state,
        state: action.payload?.state,
        country: action.payload?.country,
      };
    },
  },
});

const { actions, reducer } = oneTrustLocale;

export const { setOneTrustLocale } = actions;

export default reducer;
